import {DANGER, INFO, SUCCESS} from "../constants/ActionTypes";
import IntlMessages from "./IntlMessages";
import React from "react";
import {showBBNotification} from "./bbHelpers";
import {isNetworkError} from "./bbHelpers";

/**
 *
 * @param requestObject
 * @param nameOfAction
 * @param showUserMessages
 * @param showConsoleLogs
 * @param persistSuccessMessage
 * @param ignoreSuccessMessage
 * @returns {boolean}
 */
export const bbDeviantRequestHandler = (requestObject, nameOfAction, showUserMessages = false, showConsoleLogs = false, persistSuccessMessage = false, ignoreSuccessMessage = true) => {
    if (requestObject) {
        //destructure the request
        const {
            statusText,
            status,
            data,
            config,
            request,
            response,
            isAxiosError,
            code
        } = requestObject;

        if(showConsoleLogs) {
            console.info(`${nameOfAction} request: response.`, requestObject, typeof(requestObject), "keys for request object: ", Object.keys(requestObject));
            console.info(requestObject);
            console.info("request.statusText", statusText);//error: undefined | success: all caps code, like CREATED
            console.info("request.status", status);//error: undefined | success: code as a number
            console.info("request.data", data); //error: undefined | success: response in an object (e.g. access .message)
            console.info("request.config", config); //error: object with original request | success: same as error
            console.info("request.request", request); //error: object with .status, .response (with raw json) | success: same as error
            console.info("request.response", response); //error: object with .data as an object (e.g. access .message), .status, and .config with request | success: undefined
            console.info("Is Axios error?", isAxiosError); //error: true | success: undefined
            console.info("request.code", code); //error: object with .data as an object (e.g. access .message), .status, and .config with request | success: undefined
            /*  jfd*******************************
             *   Conclusion:
             *      - check for status code using request.request.status
             *      - if error, message will be in request.response.data.[name of the message key]
             *      - if success, message will be in request.data.[name of the message key]
             *      - have asked john to put all messages in the userMessage key.
                 ********************************** */
        }

        if (isNetworkError(requestObject)) {  //jfd: a code of 0 is probably an ERR_NAME_NOT_RESOLVED so most everything will be null.
            /*  jfd*******************************
             *   First: check for internet connection.
                 ********************************** */
            console.error(`${nameOfAction} isNetworkError error. (No internet connection or server unreachable?)`);
            if(showConsoleLogs) {
                console.error( requestObject, "response data:  ", requestObject);
            }
            // if(showUserMessages) {
            showBBNotification(
                DANGER,
                <IntlMessages id={`general.error.network`}/>,
                <IntlMessages id={`general.error.network.detail`}/>,
                true
            );
            // }
            return false;
        } else if (code === 'ECONNABORTED') {  //jfd: response is a timeout
            /*  jfd*******************************
             *   Then for special case if it was a timeout
                 ********************************** */
            console.error(`${nameOfAction} timeout error.`);
            if(showConsoleLogs) {
                console.error(requestObject, "response data:  ", requestObject);
            }

            // if(showUserMessages) {
            showBBNotification(
                DANGER,
                <IntlMessages id={`general.error.network`}/>,
                <IntlMessages id={`general.error.network.timeout`}/>,
                true
            );
            // }
            return false;
        } else if (status >= 200 && status < 300) {  //jfd: response is a success code
            /*  jfd*******************************
             *   Then for a success case
                 ********************************** */
            console.log(`%c${nameOfAction} request successful.`, "color:green;");
            if(showUserMessages && ignoreSuccessMessage && requestObject.response && requestObject.response.userMessage) {
                showBBNotification(
                    INFO,
                    <IntlMessages id={`${nameOfAction}.success`}/>,
                    data && data.userMessage ? data.userMessage : data && data.message ? data.message : <IntlMessages id={`${nameOfAction}.success.detail`}/>,
                    true
                );

            }
            return true;

        } else { //jfd: some other error occurred
            /*  jfd*******************************
             *   Anything else is an error where the details should be clearly in the requestObject's data
                 ********************************** */
            console.error(`${nameOfAction} error.`, requestObject, "response data:  ", requestObject);
            if(showUserMessages && response && response.data) {
                showBBNotification(
                    DANGER,
                    <IntlMessages id={`${nameOfAction}.error`}/>,
                    //TODO: safely open response
                    response.data.message
                        ? response.data.message
                        : response.data.userMessage
                            ? response.data.userMessage
                            : response.data.responseText
                                ? response.data.responseText
                                : response.data.description
                                    ? response.data.description
                                    : response.data.error
                                        ? response.data.error
                                        : <IntlMessages id={`${nameOfAction}.error.detail`}/>,
                    true
                );
            } else{
                console.warn("bbStandardRequestHandle, returning an unknown error. showUserMessages is", showUserMessages, "response is", response)
            }
            return false;
        }
    } else {
        return false
    }
}